/**
 * DG Custom - Vendor ID Variant Handler
 * Updates vendor_id input when variant changes
 */

function initializeVendorId(container) {
  const variantPicker = container.querySelector('variant-picker');
  const variantVendorIdDataElement = container.querySelector('[data-vendor-id-variants]');

  if (!variantPicker || !variantVendorIdDataElement) return;

  const variantVendorIdData = JSON.parse(variantVendorIdDataElement.textContent);
  const vendorIdFormInput = container.querySelector('input[data-vendor-id-input]');

  variantPicker.addEventListener('on:variant:change', (event) => {
    const selectedVariant = event.detail.variant;
    const selectedVariantVendorId = variantVendorIdData.variants.find((variant) => variant.id === selectedVariant.id);

    if (vendorIdFormInput && selectedVariantVendorId) {
      vendorIdFormInput.value = selectedVariantVendorId.vendor_id || '';
    }
  });
}

function handleDocumentClick(event) {
  if (event.target.matches('.js-quick-add')) {
    const quickAddDrawer = document.querySelector('quick-add-drawer');
    if (quickAddDrawer) {
      setTimeout(() => {
        const isOpen = quickAddDrawer.hasAttribute('open');
        if (isOpen) {
          initializeVendorId(quickAddDrawer);
        }
      }, 200);
    }
  }
}

function init() {
  document.addEventListener('click', handleDocumentClick.bind(this));
  const productMain = document.querySelector('.product-main');
  if (productMain) {
    initializeVendorId(productMain);
  }
}

init();
